import { Injectable } from '@angular/core';
import { LynxAuthService } from './core/services/auth.service';
import { LynxLocalizeRouterService } from './core/services/localize-router.service';

@Injectable()
export class AuthCheck {
  constructor(
    private authService: LynxAuthService,
    private localizeRouterService: LynxLocalizeRouterService
  ) {}

  canActivate(): boolean {
    const isLoggedIn = this.authService.isLoggedIn;
    if (!isLoggedIn) {
      this.localizeRouterService.translateRoute('login');
    }
    return isLoggedIn;
  }
}
